import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Tack för dina svar!</h1>
      <p style={{ fontSize: '18px', marginBottom: '30px' }}>
        Dina svar har tagits emot. Tack för din medverkan!
      </p>
      
      <button 
        onClick={() => navigate('/')}
        style={{ padding: '15px 30px', fontSize: '16px' }}
      >
        Tillbaka till startsidan
      </button>
    </div>
  );
};

export default SuccessPage;